<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid>
        <v-row>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card" style="width:100%">
                <v-card-title>Admin</v-card-title>
                <v-card-subtitle class="caption">CSAIL HR Management area for admins</v-card-subtitle>
                <v-divider></v-divider>

                <v-card-text>
                    <div>
                        <router-link to="/admin/taxonomies" style="text-decoration:none">
                            <h3 class="pt-5">
                              <v-icon color="primary darken-1" class="pr-3">mdi-office-building-cog</v-icon>Lab Taxonomies
                            </h3>
                        </router-link>
                        <p>Add, update, or remove taxonomies for the lab.</p>
                    </div>
                    <div>
                        <router-link to="/admin/roles" style="text-decoration:none">
                            <h3 class="pt-5">
                              <v-icon color="primary darken-1" class="pr-3">mdi-office-building-cog</v-icon>User Roles
                            </h3>
                        </router-link>
                        <p>Add, update or remove user role options.</p>
                    </div>
                    <div>
                        <router-link to="/admin/settings" style="text-decoration:none">
                            <h3 class="pt-5">
                              <v-icon color="primary darken-1" class="pr-3">mdi-cog</v-icon>Settings
                            </h3>
                        </router-link>
                        <p>Import reservations into this application from a csv file</p>
                    </div>
                    <!-- <div>
                        <a href="/admin/access" style="text-decoration:none">
                          <h3 class="pt-5">
                            <v-icon color="primary darken-1" class="pr-3">mdi-account-lock</v-icon>Space Permissions
                          </h3>
                        </a>
                        <p>Set permissions for spaces, who can access</p>
                    </div> -->

                </v-card-text>

            </v-card>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';

  export default {
    name: 'MitAdminPage',
    components: {
    },
    data: function() {
      return {
        showResetFeature:false,
        resetByEmail:false
      }
    },
    created() {
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
